import { ChevronDownIcon, ChevronUpDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import { Sort } from "hooks/useSortToggler";

interface TableSortIconProps<T> {
    sort?: Sort;
    sortBy?: T[keyof T] | string;
    field: T[keyof T] | string;
}

export const TableSortIconVendor = <T,>({ sort, sortBy, field }: TableSortIconProps<T>) => {
    if (sortBy !== field) {
        return <ChevronUpDownIcon className="ml-2 mt-0.5 h-4 w-4 text-white" />;
    }
    if (sort === "asc") {
        return <ChevronUpIcon className="ml-2 mt-0.5 h-4 w-4 text-white" />;
    } else {
        return <ChevronDownIcon className="ml-2 mt-0.5 h-4 w-4 text-white" />;
    }
};
